import { SaveTheme } from '@/domain/usecases'
import { ThemeModel } from '@/domain/models'
import { AccessDeniedError, ForbiddenError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'
import { HttpClient, HttpRequest, HttpStatusCode } from '@/data/protocols'

export class RemoteSaveTheme implements SaveTheme {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<string>
  ) { }

  async save (params: ThemeModel): Promise<string> {
    const request: HttpRequest = {
      url: `${this.url}/api/portal/tema`,
      method: 'post',
      body: params
    }

    const { statusCode, body } = await this.httpClient.request(request)

    switch (statusCode) {
      case HttpStatusCode.ok:
        if (!body) {
          throw new UnexpectedResultFormatError()
        }
        return body
      case HttpStatusCode.forbidden: throw new ForbiddenError(body)
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
